import { ToastPosition, toast } from "react-toastify";

interface Toastify {
  success: string;
  error: string;
}

export function useToast() {
  const toastify = (
    type: keyof Toastify,
    message: string,
    position: ToastPosition,
  ) => {
    toast[type](message, {
      position,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  return { toastify };
}
